import React, { useEffect, useState } from "react";
import { Field, FieldArray, useFormikContext } from "formik";
import { isEmpty, isNull } from "lodash";
import { Button } from "react-bootstrap";
import {
  faPencilAlt,
  faCheck,
  faTrashAlt,
  faTimes,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FieldInputNumber,
  FieldInputPercentage,
} from "../../../../../components";

const TierDetails = ({ fields, tieredFeeType, isSave, isEdit, isAdd }) => {
  const {
    values,
    setFieldError,
    setFieldValue,
    handleChange,
  } = useFormikContext();
  const [edit, setEdit] = useState([isAdd]);
  // const [edit, setEdit] = useState([true]);

  useEffect(() => {
    const temp = isAdd ? [true] : [false];
    setEdit(temp);
  }, []);
  const [error, setError] = useState(false);
  const [addTierMaxLimit, setAddTierMaxLimit] = useState(999);
  useEffect(() => {
    tieredFeeType == "Calendar Days" ||
    tieredFeeType == "Business Days" ||
    tieredFeeType == "Weeks"
      ? setAddTierMaxLimit(999)
      : setAddTierMaxLimit(99);
  }, [tieredFeeType]);
  useEffect(() => {
    let tieredDetails = values.holdingPeriodTieredFees;

    if (!isEmpty(tieredDetails) && !isAdd) {
      setEdit(
        tieredDetails.map((_) => {
          return false;
        })
      );
    }
  }, []);

  const check = (data, index) => {
    setError(true);
    if (data.toHoldingPeriod == null)
      setFieldError(
        `${fields.holdingPeriodTieredFees}[${index}].toHoldingPeriod`,
        "TDI038 : Required"
      );
    else
      setFieldError(
        `${fields.holdingPeriodTieredFees}[${index}].toHoldingPeriod`,
        ""
      );
    if (data.redemptionFee == null)
      setFieldError(
        `${fields.holdingPeriodTieredFees}[${index}].redemptionFee`,
        "TDI039 : Required"
      );
    else
      setFieldError(
        `${fields.holdingPeriodTieredFees}[${index}].redemptionFee`,
        ""
      );

    if (data.toHoldingPeriod < data.fromHoldingPeriod) {
      data.toHoldingPeriod != null &&
        setFieldError(
          `${fields.holdingPeriodTieredFees}[${index}].toHoldingPeriod`,
          "TDI065 : To Holding Period should be greater than From Holding Period"
        );
    } else
      setFieldError(
        `${fields.holdingPeriodTieredFees}[${index}].toHoldingPeriod`,
        ""
      );

    if (
      data.toHoldingPeriod != null &&
      data.redemptionFee != null &&
      data.toHoldingPeriod > data.fromHoldingPeriod
    ) {
      setError(false);
      setEdit(
        edit.map((data, i) => {
          if (i == index) {
            return !data;
          }
          return data;
        })
      );
    }
  };

  const clear = (data, index) => {
    setFieldError(
      `${fields.holdingPeriodTieredFees}[${index}].toHoldingPeriod`,
      null
    );
    setFieldValue(
      `${fields.holdingPeriodTieredFees}[${index}].toHoldingPeriod`,
      null
    );
    setFieldError(
      `${fields.holdingPeriodTieredFees}[${index}].redemptionFee`,
      null
    );
    setFieldValue(
      `${fields.holdingPeriodTieredFees}[${index}].redemptionFee`,
      null
    );

    setEdit(
      edit.map((data, i) => {
        if (i == index) {
          return !data;
        }
        return data;
      })
    );
  };

  const deleteTier = (index) => {
    const filtered = (values.holdingPeriodTieredFees = values.holdingPeriodTieredFees.filter(
      (_, i) => i != index
    ));
    setFieldValue(fields.holdingPeriodTieredFees, filtered);
    edit.splice(-1);
  };

  return (
    <FieldArray name={fields.holdingPeriodTieredFees}>
      {({ remove, push }) => (
        <>
          <div className="tier-container">
            <div className="d-flex justify-content-between">
              <div className="fw-500">Tier Details</div>
              <Button
                size="sm"
                variant="secondary"
                disabled={
                  (isEdit &&
                    !isSave &&
                    !isEmpty(values.holdingPeriodTieredFees) &&
                    !error) ||
                  values.holdingPeriodTieredFees[
                    values.holdingPeriodTieredFees.length - 1
                  ].toHoldingPeriod == null ||
                  values.holdingPeriodTieredFees[
                    values.holdingPeriodTieredFees.length - 1
                  ].redemptionFee == null ||
                  values.holdingPeriodTieredFees[
                    values.holdingPeriodTieredFees.length - 1
                  ].toHoldingPeriod == addTierMaxLimit ||
                  (!isEmpty(values.holdingPeriodTieredFees) &&
                    edit[values.holdingPeriodTieredFees.length - 1])
                }
                onClick={() => {
                  setEdit([...edit, true]);
                  push({
                    tier:
                      !isEmpty(values.holdingPeriodTieredFees) &&
                      values.holdingPeriodTieredFees[
                        values.holdingPeriodTieredFees.length - 1
                      ].tier + 1,
                    fromHoldingPeriod:
                      !isEmpty(values.holdingPeriodTieredFees) &&
                      values.holdingPeriodTieredFees[
                        values.holdingPeriodTieredFees.length - 1
                      ].toHoldingPeriod + 1,
                    toHoldingPeriod: null,
                    redemptionFee: null,
                  });
                }}
              >
                Add Tier
              </Button>
            </div>
            {!isEmpty(values.holdingPeriodTieredFees) &&
              values.holdingPeriodTieredFees.map((data, index) => {
                const fieldName = `${fields.holdingPeriodTieredFees}[${index}]`;
                if (!edit[index]) {
                  return (
                    <div className="tier-card">
                      <div className="d-flex justify-content-around">
                        <div>
                          <p className="ft-12 mt-15 mb-15">Tier</p>
                          <p className="ft-14 black-text">{data.tier}</p>
                        </div>
                        <div>
                          <p className="ft-12 mt-15 mb-15">
                            From {tieredFeeType}
                          </p>
                          <p className="ft-14 black-text">
                            {data.fromHoldingPeriod}
                          </p>
                        </div>
                        <div>
                          <p className="ft-12  mt-15 mb-15">
                            To {tieredFeeType}
                          </p>
                          <p className="ft-14 black-text">
                            {data.toHoldingPeriod}
                          </p>
                        </div>
                        <div>
                          <p className="ft-12 mt-15 mb-15">Redemption Fee %</p>
                          <p className="ft-14 black-text">
                            {data.redemptionFee && data.redemptionFee + " %"}
                          </p>
                        </div>
                        <div className="d-flex">
                          <div className="mr-4">
                            {index == 0 ? (
                              values.holdingPeriodTieredFees.length == 1 ? (
                                isEdit && !isSave ? (
                                  <div>
                                    <FontAwesomeIcon
                                      icon={faPencilAlt}
                                      size="lg"
                                      color="grey"
                                      style={{
                                        marginTop: "35px",
                                        cursor: "not-allowed",
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <>
                                    <div>
                                      <FontAwesomeIcon
                                        icon={faPencilAlt}
                                        size="lg"
                                        color="#3a3974"
                                        style={{
                                          marginTop: "35px",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          setEdit(
                                            edit.map((data, i) => {
                                              if (i == index) {
                                                return !data;
                                              }
                                              return data;
                                            })
                                          );
                                        }}
                                      />
                                    </div>
                                  </>
                                )
                              ) : (
                                <div>
                                  <FontAwesomeIcon
                                    icon={faPencilAlt}
                                    size="lg"
                                    color="grey"
                                    style={{
                                      marginTop: "35px",
                                      cursor: "not-allowed",
                                    }}
                                  />
                                </div>
                              )
                            ) : index ==
                              values.holdingPeriodTieredFees.length - 1 ? (
                              isEdit && !isSave ? (
                                <div className="d-flex">
                                  <div className="pr-4">
                                    <FontAwesomeIcon
                                      icon={faPencilAlt}
                                      size="lg"
                                      color="grey"
                                      style={{
                                        marginTop: "35px",
                                        cursor: "not-allowed",
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <FontAwesomeIcon
                                      icon={faTrashAlt}
                                      size="lg"
                                      color="grey"
                                      style={{
                                        marginTop: "35px",
                                        cursor: "not-allowed",
                                      }}
                                    />
                                  </div>
                                </div>
                              ) : (
                                <div className="d-flex">
                                  <div className="pr-4">
                                    <FontAwesomeIcon
                                      icon={faPencilAlt}
                                      size="lg"
                                      color="#3a3974"
                                      style={{
                                        marginTop: "35px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setEdit(
                                          edit.map((data, i) => {
                                            if (i == index) {
                                              return !data;
                                            }
                                            return data;
                                          })
                                        );
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <FontAwesomeIcon
                                      icon={faTrashAlt}
                                      size="lg"
                                      color="red"
                                      style={{
                                        marginTop: "35px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => deleteTier(index)}
                                    />
                                  </div>
                                </div>
                              )
                            ) : (
                              <div className="d-flex">
                                <div className="pr-4">
                                  <FontAwesomeIcon
                                    icon={faPencilAlt}
                                    size="lg"
                                    color="grey"
                                    style={{
                                      marginTop: "35px",
                                      cursor: "not-allowed",
                                    }}
                                  />
                                </div>
                                <div>
                                  <FontAwesomeIcon
                                    icon={faTrashAlt}
                                    size="lg"
                                    color="grey"
                                    style={{
                                      marginTop: "35px",
                                      cursor: "not-allowed",
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }
                if (edit[index]) {
                  return (
                    <div className="tier-card">
                      <div className="d-flex justify-content-around">
                        <Field
                          name={`${fieldName}.tier`}
                          label="Tier"
                          isRequired
                          size="sm"
                          type="number"
                          autoComplete="off"
                          disabled={true}
                          component={FieldInputNumber}
                        />
                        <Field
                          name={`${fieldName}.fromHoldingPeriod`}
                          label={`From ${tieredFeeType}`}
                          preventNegative
                          isRequired
                          size="sm"
                          type="number"
                          autoComplete="off"
                          min={0}
                          disabled={true}
                          component={FieldInputNumber}
                        />
                        <Field
                          name={`${fieldName}.toHoldingPeriod`}
                          label={`To ${tieredFeeType}`}
                          preventNegative
                          isRequired
                          size="sm"
                          type="number"
                          autoComplete="off"
                          placeholder="Enter"
                          min={0}
                          max={addTierMaxLimit}
                          onChange={handleChange}
                          component={FieldInputNumber}
                        />
                        <Field
                          name={`${fieldName}.redemptionFee`}
                          label="Redemption fee %"
                          preventNegative
                          isRequired
                          size={"xs"}
                          type="number"
                          autoComplete="off"
                          onChange={handleChange}
                          placeholder="Enter"
                          min={0}
                          component={FieldInputPercentage}
                        />
                        <div className="d-flex">
                          <div className="mr-4">
                            <FontAwesomeIcon
                              icon={faCheck}
                              size="lg"
                              color="green"
                              style={{ marginTop: "35px", cursor: "pointer" }}
                              onClick={() => check(data, index)}
                            />
                          </div>
                          {index === 0 ? (
                            <></>
                          ) : (
                            <>
                              <div>
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  size="lg"
                                  color="red"
                                  style={{
                                    marginTop: "35px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => clear(data, index)}
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
          </div>
        </>
      )}
    </FieldArray>
  );
};

export default TierDetails;
